export default "__VITE_ASSET__cHQ9MORb__"